// https://gist.github.com/peduarte/7ee475dd0fae1940f857582ecbb9dc5f
function debounce(func) {
	const wait = arguments.length <= 1 || arguments[1] === undefined ? 100 : arguments[1];

	let timeout = void 0;
	return function() {
		const _this = this;

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		clearTimeout(timeout);
		timeout = setTimeout(() => {
			func.apply(_this, args);
		}, wait);
	};
}
module.exports = debounce;
